<mat-form-field appearance="fill" class="w-full">
  <mat-select #selectRef multiple [value]="selectedTechCodes" (openedChange)="onPanelOpen()"
    [disableOptionCentering]="true" placeholder="Select Technicians" panelClass="no-auto-close">
    <mat-select-trigger>
      {{ getSelectedTechNames() }}
    </mat-select-trigger>

    <!-- Search Input -->
    <mat-option disabled>
      <input type="text" placeholder="Search technician..." [(ngModel)]="searchValue"
        (ngModelChange)="filterTechnicians()" matInput />
    </mat-option>

    <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.employeeCode"
      (click)="toggleTechnician(tech.employeeCode, selectRef)"
      [class.selected-option]="selectedTechCodes.includes(tech.employeeCode)">
      {{ tech.fullName }}
    </mat-option>
  </mat-select>
</mat-form-field>